<template>
    <div class="container-xxl padding-container-matrix">
        <div class="row justify-content-center">
            <div class="col-matrix">
                <div class="row justify-content-lg-between">
                    <div class="col-12 col-lg-5">
                        <div class="text-editor" v-html="textContentLeft"></div>
                    </div>
                    <div class="col-12 col-lg-5">
                        <div class="text-editor" v-html="textContentRight"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
// import AssetLoader from '@/components/helpers/AssetLoader'

export default {
    name: 'textTwoColumns',
    components: {
        // AssetLoader
    },
    props: {
        textContentLeft: {
            type: String,
            required: true,
        },
        textContentRight: {
            type: String,
            required: true,
        },
    },
    computed: {
        pageIsLoaded() {
            return this.contentIsLoaded && this.globalsIsLoaded
        },
        ...mapState(['contentIsLoaded', 'globalsIsLoaded']),
        ...mapGetters(['seo', 'content', 'globals']),
    },
    methods: {
        ...mapActions(['setErrorsReportMsg']),
    },
    // On loaded...
    mounted() {},
}
</script>
